import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { getFirstHumanReadableTextFromHtml } from '../../helpers/dom';

export interface Article {
	title: string;
	body: string;
}

export interface ArticleCardProps {
	article: Article;
	onReadMore: () => void;
}

export const ArticleCard = React.forwardRef<
	HTMLDivElement,
	ArticleCardProps & React.HTMLProps<HTMLDivElement>
>(({ article, onReadMore, ...props }, ref) => {
	const { t } = useTranslation();
	const [firstReadableText] = React.useState<undefined | string>(
		getFirstHumanReadableTextFromHtml(article.body)
	);

	return (
		<div
			ref={ref}
			className="c-article-card text-body border-gray-40 relative px-6 py-4 mb-2 bg-white border border-solid rounded-md"
			{...props}
		>
			<div className="absolute inset-0 overflow-hidden rounded-md">
				<div
					className="bg-ongreen absolute top-0 bottom-0 left-0"
					style={{ width: '5px' }}
				></div>
			</div>

			<p data-testid="article-title" className="text-body-sm font-bold">
				{article.title}
			</p>

			{firstReadableText && (
				<p data-testid="article-excerpt" className="text-body-sm line-clamp-2">
					{firstReadableText}
				</p>
			)}

			<span
				aria-hidden="true"
				className="text-link text-sm font-bold underline"
			>
				{t('articlesMessage:readMore')}
			</span>

			<button
				type="button"
				data-testid="read-more-cta"
				data-tag-name="read more cta"
				className="c-article-card-cta text-link absolute z-20 w-full p-0 bg-transparent rounded-md cursor-pointer"
				style={{ top: '1px', right: '1px', bottom: '1px', left: '1px' }}
				onClick={() => onReadMore()}
			>
				<span className="sr-only">{article.title} - Read Article</span>
			</button>
		</div>
	);
});

export default ArticleCard;
